import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VignetteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vignette"}/>
}
